export default "__VITE_ASSET__CdOCC2sb__"